import workspaceQuery from '../../../graphql/queries/company/DocumentSummaryWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/company/DocumentSummaryQuery.graphql';
import fragment from '../../../graphql/fragments/company/DocumentSummaryFragment.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const DocumentSummary: EntityType = {
  type: 'DocumentSummary',
  title: 'Printed Documents',
  workspaceUrl: '/Company/DocumentSummary/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  fragment,
  screenReference: 'DOCUMENT_SUMMARY',
  operations: ALLOW_VIEW,
};

export default DocumentSummary;
